import React from "react";
// import Ajax from "../Ajax";


export default class ErrorBoundary extends React.Component {

    constructor(props) {

        super(props)

        this.state = {
            hasError: false,
            error: "",
            errorInfo: null
        }
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error: error }
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        this.setState({errorInfo: errorInfo})
        this.writeLogToServer(`Frontend error: ${error.toString()}\n${errorInfo?.componentStack}`)
    }

    writeLogToServer (message) {
        // Ajax.Session.Log(message)
    }

    render () {
        
        // var showStackTrace = process.env.NODE_ENV === "development" && this.errorInfo?.componentStack

        if (!this.hasError) {
            return <>{this.props.children}</>
        }

        return (
            <div className="error-boundary">
                <h3>Front end error</h3>

                <p>{this.error.toString()}</p>

                <p className="code">{this.errorInfo?.componentStack}</p>
            </div>
        )
    }
  }